module.exports = __webpack_public_path__ + "img/invoices.5ea87978.svg";